
import { defineComponent, PropType, computed } from 'vue'
import { SeminarAttributes } from '@/types/models/seminar'

export default defineComponent({
  props: {
    seminarDetails: {
      type: Object as PropType<SeminarAttributes | undefined>,
      'default': () => (undefined),
    }
  },
  setup(props) {
    const categoryName = computed((): string => {
      if (props.seminarDetails) {
        return props.seminarDetails.seminar_category.id === 1 || props.seminarDetails.seminar_category.id === 2 ? 'セミナー' : props.seminarDetails.seminar_category.name
      }
      return ''
    })

    return {
      categoryName
    }
  },
})
